import axios from 'axios';
import apiConfig from '../api.config';

export default function getMailTemplateDetail({ hotelId, templateId }) {
  const {
    host,
    URIs: { mailTemplateDetail },
  } = apiConfig;

  const uri = `${host}${mailTemplateDetail}`
    .replace(':hotelId', hotelId)
    .replace(':guestlinkId', templateId);

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
